// assets/custom.js

// =========================================================
// Manual Wishlist - LocalStorage Based (No XB Dependencies)
// =========================================================

(function() {
  'use strict';

  const WISHLIST_KEY = 'manual_wishlist';
  let wishlist = [];
  let toastTimeout;

  // Load wishlist from localStorage
  function loadWishlist() {
    try {
      const stored = localStorage.getItem(WISHLIST_KEY);
      wishlist = stored ? JSON.parse(stored) : [];
      console.log('[Wishlist] Loaded:', wishlist.length, 'items');
      return wishlist;
    } catch (e) {
      console.error('[Wishlist] Load error:', e);
      wishlist = [];
      return [];
    }
  }

  // Save wishlist to localStorage
  function saveWishlist() {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
      console.log('[Wishlist] Saved:', wishlist.length, 'items');
      updateHeaderCount();
    } catch (e) {
      console.error('[Wishlist] Save error:', e);
    }
  }

  // Check if product is in wishlist
  function isInWishlist(productId) {
    return wishlist.some(item => item.id === productId);
  }

  // Add product to wishlist
  function addToWishlist(productData) {
    console.log('[Wishlist] Adding product:', productData);
    if (!isInWishlist(productData.id)) {
      wishlist.push(productData);
      saveWishlist();
      showToast(true);
      console.log('[Wishlist] Product added. Total items:', wishlist.length);
      return true;
    }
    console.log('[Wishlist] Product already in wishlist');
    return false;
  }

  // Remove product from wishlist
  function removeFromWishlist(productId) {
    const index = wishlist.findIndex(item => item.id === productId);
    if (index > -1) {
      wishlist.splice(index, 1);
      saveWishlist();
      showToast(false);
      return true;
    }
    return false;
  }

  // Show toast notification
  function showToast(isAdded) {
    const existingToast = document.querySelector('.wishlist-toast');
    if (existingToast) existingToast.remove();
    if (toastTimeout) clearTimeout(toastTimeout);

    const toast = document.createElement('div');
    toast.className = `wishlist-toast ${isAdded ? 'added' : 'removed'}`;
    toast.innerHTML = `
      <svg class="wishlist-toast-icon" viewBox="0 0 24 24">
        <path d="M19.6706 5.4736C17.6806 3.8336 14.7206 4.1236 12.8906 5.9536L12.0006 6.8436L11.1106 5.9536C9.29063 4.1336 6.32064 3.8336 4.33064 5.4736C2.05064 7.3536 1.93063 10.7436 3.97063 12.7836L11.6406 20.4536C11.8406 20.6536 12.1506 20.6536 12.3506 20.4536L20.0206 12.7836C22.0706 10.7436 21.9506 7.3636 19.6706 5.4736Z"/>
      </svg>
      <span>${isAdded ? 'Added to Wishlist' : 'Removed from Wishlist'}</span>
    `;

    document.body.appendChild(toast);
    setTimeout(() => toast.classList.add('show'), 100);

    toastTimeout = setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }

  // Update button visual state
  function updateButtonState(button) {
    const productId = button.dataset.productId;
    if (isInWishlist(productId)) {
      button.classList.add('in-wishlist');
      button.setAttribute('aria-label', 'Remove from wishlist');
    } else {
      button.classList.remove('in-wishlist');
      button.setAttribute('aria-label', 'Add to wishlist');
    }
  }

  // Update all buttons
  function updateAllButtons() {
    document.querySelectorAll('.manual-wishlist-btn').forEach(updateButtonState);
  }

  // Update header wishlist count
  function updateHeaderCount() {
    // This will update any wishlist counter in header if exists
    const counter = document.querySelector('.wishlist-count, [data-wishlist-count]');
    if (counter) {
      counter.textContent = wishlist.length;
    }
  }

  // Handle button click (heart buttons on product cards)
  function handleWishlistButtonClick(e) {
    const button = e.target.closest('.manual-wishlist-btn');
    if (!button) return;

    e.preventDefault();
    e.stopPropagation();

    const productData = {
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      price: button.dataset.productPrice,
      comparePrice: button.dataset.productComparePrice,
      vendor: button.dataset.productVendor,
      image: button.dataset.productImage,
      url: button.dataset.productUrl,
      variantId: button.dataset.variantId
    };

    console.log('[Wishlist] Click:', productData.title);

    if (isInWishlist(productData.id)) {
      removeFromWishlist(productData.id);
    } else {
      addToWishlist(productData);
    }

    updateAllButtons();
  }

  // Handle remove button click (X button on wishlist page)
  function handleRemoveButtonClick(e) {
    const removeBtn = e.target.closest('.wishlist-item__remove');
    if (!removeBtn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const productId = removeBtn.dataset.productId;
    console.log('[Wishlist] Removing product:', productId);

    // Disable button to prevent double clicks
    removeBtn.disabled = true;

    removeFromWishlist(productId);
    renderWishlistPage();
    updateAllButtons();
  }

  // Render wishlist page products
  function renderWishlistPage() {
    const container = document.querySelector('.wishlist-products-container, [data-wishlist-products]');
    if (!container) {
      console.log('[Wishlist] No container found');
      return;
    }

    console.log('[Wishlist] Rendering', wishlist.length, 'products:', wishlist);

    if (wishlist.length === 0) {
      container.innerHTML = `
        <div class="wishlist-empty">
          <img src="https://cdn.shopify.com/s/files/1/0651/1096/6381/files/Group_1000002206.png?v=1758793238"
               alt="Empty wishlist"
               class="wishlist-empty__image">
        </div>
      `;
      return;
    }

    const html = wishlist.map(product => {
      console.log('[Wishlist] Rendering product:', product);
      // Format price in Thai Baht
      const formatPrice = (priceInCents) => {
        if (!priceInCents) return '';
        const price = parseInt(priceInCents) / 100; // Convert cents to baht
        return '฿' + price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      };

      const formattedPrice = formatPrice(product.price);
      const formattedComparePrice = formatPrice(product.comparePrice);

      const hasComparePrice = product.comparePrice &&
                              product.comparePrice !== 'null' &&
                              product.comparePrice !== '' &&
                              parseInt(product.comparePrice) > parseInt(product.price);

      return `
      <div class="wishlist-item card-wrapper">
        <button class="wishlist-item__remove" data-product-id="${product.id}" aria-label="Remove from wishlist">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
        <a href="${product.url}" class="wishlist-item__image-link">
          <div class="wishlist-item__image">
            <img src="${product.image}" alt="${product.title}" loading="lazy">
          </div>
        </a>
        <div class="card__content">
          <div class="card__information">
            ${product.vendor ? `<div class="wishlist-item__brand">${product.vendor}</div>` : ''}
            <h3 class="wishlist-item__product-title">
              <a href="${product.url}">
                ${product.title}
              </a>
            </h3>
            <div class="wishlist-item__prices">
              ${hasComparePrice ? `
                <div class="wishlist-item__price-row">
                  <span class="wishlist-item__sale-price">${formattedPrice}</span>
                  <s class="wishlist-item__original-price">${formattedComparePrice}</s>
                </div>
              ` : `
                <div class="wishlist-item__price-row">
                  <span class="wishlist-item__regular-price">${formattedPrice}</span>
                </div>
              `}
            </div>
          </div>
        </div>
      </div>
    `;
    }).join('');

    container.innerHTML = html;
  }

  // Initialize
  function init() {
    console.log('[Wishlist] Initializing manual wishlist...');
    console.log('[Wishlist] Current path:', window.location.pathname);

    // Load wishlist from localStorage
    loadWishlist();

    // Update button states
    updateAllButtons();

    // Update header count
    updateHeaderCount();

    // Render wishlist page if on wishlist page
    const isWishlistPage = window.location.pathname.includes('wishlist') || window.location.pathname.includes('swym');
    console.log('[Wishlist] Is wishlist page?', isWishlistPage);

    if (isWishlistPage) {
      console.log('[Wishlist] Calling renderWishlistPage...');
      renderWishlistPage();
    }

    // Listen for clicks on heart buttons and remove buttons
    document.addEventListener('click', handleWishlistButtonClick);
    document.addEventListener('click', handleRemoveButtonClick);

    // Watch for new buttons (dynamic content)
    const observer = new MutationObserver(() => {
      updateAllButtons();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    console.log('[Wishlist] ✓ Ready with', wishlist.length, 'items');
  }

  // Start when ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for debugging
  window.ManualWishlist = {
    get: () => wishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    clear: () => {
      wishlist = [];
      saveWishlist();
      updateAllButtons();
      renderWishlistPage();
    }
  };

})();

// =========================================================
// Split Banner Slider - Auto-advance functionality
// =========================================================

(function () {
  const SCOPE_SELECTOR = 'section.banner.banner--split slider-component';

  function getTrack(sc) {
    return sc.querySelector('.slider__content');
  }

  function getSlides(sc) {
    return sc.querySelectorAll('.banner__box');
  }

  function getCurrentIndex(sc) {
    const track = getTrack(sc);
    if (!track) return 0;
    const scrollLeft = track.scrollLeft;
    const slideWidth = track.offsetWidth;
    return Math.round(scrollLeft / slideWidth);
  }

  function scrollToSlide(sc, index) {
    const track = getTrack(sc);
    if (!track) return;
    const slideWidth = track.offsetWidth;
    track.scrollTo({
      left: slideWidth * index,
      behavior: 'smooth'
    });
  }

  function autoAdvance(sc) {
    const slides = getSlides(sc);
    if (slides.length <= 1) return;

    let current = getCurrentIndex(sc);
    current = (current + 1) % slides.length;
    scrollToSlide(sc, current);
  }

  document.querySelectorAll(SCOPE_SELECTOR).forEach(sc => {
    setInterval(() => autoAdvance(sc), 5000);
  });
})();

/* =========================================================
   Mobile GNB Icons - Precise Target Move Strategy
   모바일: 특정 아이콘만 드로어로 이동, PC: 헤더 원위치 유지
   중복 렌더 금지, 클론 금지, 단일 인스턴스 이동/복귀만
   ========================================================= */
(function(){
  'use strict';

  const mq = window.matchMedia('(max-width: 749px)');

  // 이동 대상 노드들 (우선순위 순서)
  const TARGETS = [
    'header .xb-wishlist-header-container',
    // 필요 시 추가: 'header .header__icon--account', 'header .header__icon--cart'
  ];

  // 이동 상태 추적 (각 타깃별)
  const movedNodes = new Map(); // { selector: { node, originalParent, originalNextSibling } }

  function qs(sel, root = document) {
    return root.querySelector(sel);
  }

  /**
   * 모바일: 타깃 노드들을 드로어로 이동
   */
  function moveToDrawer() {
    const drawerSlot = qs('.menu-drawer__navigation [data-drawer-icons-slot]');
    const drawerUl = qs('.menu-drawer__navigation .drawer-icons-ul');

    if (!drawerSlot || !drawerUl) {
      console.warn('[GNB Icons] Drawer slot or UL not found');
      return;
    }

    let movedCount = 0;

    TARGETS.forEach(selector => {
      // 이미 이동했으면 스킵
      if (movedNodes.has(selector)) return;

      const node = qs(selector);
      if (!node) {
        console.warn(`[GNB Icons] Node not found: ${selector}`);
        return;
      }

      // 원위치 정보 저장 (정확한 복귀를 위해)
      const originalParent = node.parentElement;
      const originalNextSibling = node.nextElementSibling;

      // 드로어로 이동 (appendChild - 클론 아님, 이동임)
      drawerSlot.appendChild(node);

      // 이동 상태 저장
      movedNodes.set(selector, {
        node,
        originalParent,
        originalNextSibling
      });

      movedCount++;
      console.log(`[GNB Icons] Moved to drawer: ${selector}`);
    });

    // UL hidden 제거 및 body 플래그 추가
    if (movedCount > 0) {
      drawerUl.hidden = false;
      document.body.classList.add('has-drawer-icons');
      console.log(`[GNB Icons] ✓ ${movedCount} icon(s) moved, drawer visible`);
    }
  }

  /**
   * PC: 타깃 노드들을 원위치로 복귀
   */
  function moveBackToHeader() {
    movedNodes.forEach((info, selector) => {
      const { node, originalParent, originalNextSibling } = info;

      // 안전 검증
      if (!originalParent || !node) {
        console.warn(`[GNB Icons] Cannot restore ${selector}: missing parent or node`);
        return;
      }

      // 이미 원위치에 있는지 확인
      if (originalParent.contains(node)) {
        console.warn(`[GNB Icons] Already in original position: ${selector}`);
        movedNodes.delete(selector);
        return;
      }

      // 정확한 위치에 복귀 (형제 순서 유지)
      if (originalNextSibling && originalParent.contains(originalNextSibling)) {
        originalParent.insertBefore(node, originalNextSibling);
      } else {
        originalParent.appendChild(node);
      }

      console.log(`[GNB Icons] Restored to header: ${selector}`);
    });

    // 복귀 완료 후 상태 초기화
    movedNodes.clear();

    // UL 숨김 및 body 플래그 제거
    const drawerUl = qs('.menu-drawer__navigation .drawer-icons-ul');
    if (drawerUl) {
      drawerUl.hidden = true;
    }
    document.body.classList.remove('has-drawer-icons');
    console.log('[GNB Icons] ✓ Icons restored to header, drawer hidden');
  }

  /**
   * 뷰포트에 따라 이동/복귀 적용
   */
  function applyByViewport() {
    if (mq.matches) {
      // 모바일: 드로어로 이동
      moveToDrawer();
    } else {
      // PC: 헤더로 복귀
      moveBackToHeader();
    }
  }

  // 초기 적용
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyByViewport, { once: true });
  } else {
    applyByViewport();
  }

  // 뷰포트 전환 감지
  if (mq.addEventListener) {
    mq.addEventListener('change', applyByViewport);
  } else {
    // 구형 브라우저 호환
    mq.addListener(applyByViewport);
  }

  // 드로어 오픈 시점에도 재적용 (동적 DOM 변경 대응)
  document.addEventListener('toggle', (ev) => {
    const drawer = ev.target;
    if (!drawer || !drawer.classList) return;

    // 드로어가 열릴 때만
    if (drawer.classList.contains('menu-drawer-container') && drawer.open && mq.matches) {
      moveToDrawer();
    }
  });

  console.log('[GNB Icons] ✓ Precise target move strategy initialized');
})();

// Collection Page - Force Product Card Link Navigation
(function() {
  'use strict';

  // 컬렉션 페이지인지 확인 (여러 조건으로 체크)
  const isCollectionPage =
    document.body.classList.contains('template-collection') ||
    window.location.pathname.includes('/collections/') ||
    document.querySelector('.main-collection-product-grid') ||
    document.querySelector('#product-grid');

  if (!isCollectionPage) {
    console.log('[Collection Fix] Not a collection page, skipping...');
    return;
  }

  console.log('[Collection Fix] Initializing product card click fix...');

  function initProductCardFix() {
    const productCards = document.querySelectorAll('.product-card-wrapper .card__media');

    productCards.forEach(function(cardMedia) {
      const anchor = cardMedia.querySelector('a.media');

      if (!anchor) return;

      // 이미 처리된 카드는 스킵
      if (anchor.dataset.clickFixed) return;

      // 클릭 이벤트를 capture phase에서 가로채기
      cardMedia.addEventListener('click', function(e) {
        // 앵커가 아닌 다른 요소 클릭 시에만 처리
        if (e.target.tagName === 'A' || e.target.closest('a') === anchor) {
          // 앵커 자체 클릭은 정상 동작하도록 허용
          return;
        }

        // 위시리스트 버튼 클릭은 제외
        if (e.target.closest('.card__wishlist-wrapper') ||
            e.target.closest('xb-wishlist-button-collection')) {
          return;
        }

        // 배지 클릭 시에도 상품 페이지로 이동
        e.preventDefault();
        e.stopPropagation();

        const url = anchor.href;
        if (url) {
          console.log('[Collection Fix] Navigating to:', url);
          window.location.href = url;
        }
      }, true); // capture phase

      anchor.dataset.clickFixed = 'true';
    });

    console.log('[Collection Fix] ✓ Fixed', productCards.length, 'product cards');
  }

  // 페이지 로드 시 실행
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCardFix);
  } else {
    initProductCardFix();
  }

  // 동적 콘텐츠 로드 대응 (필터링 등)
  const observer = new MutationObserver(function(mutations) {
    let shouldReinit = false;

    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 &&
            (node.classList?.contains('product-card-wrapper') ||
             node.querySelector?.('.product-card-wrapper'))) {
          shouldReinit = true;
        }
      });
    });

    if (shouldReinit) {
      console.log('[Collection Fix] New products detected, reinitializing...');
      initProductCardFix();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();